import { render } from "./PartnersCard.vue?vue&type=template&id=6038a423&scoped=true"
import script from "./PartnersCard.vue?vue&type=script&lang=js"
export * from "./PartnersCard.vue?vue&type=script&lang=js"

import "./PartnersCard.vue?vue&type=style&index=0&id=6038a423&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6038a423"]])

export default __exports__